import React from 'react';
import {Modal} from '../../../../../shared/components/modal/modal';
import {useStyles} from '../../../../../shared/hooks/styles';
import {Platform, View} from 'react-native';

import {Button} from '../../../../../shared/components/button';
import {images} from '../../../../../assets/icons';
import {Text} from 'react-native';
import {useTheme} from '../../../../../shared/theme';
import {CustomScrollView} from '../../../../../shared/components/scrollView';

export type Props = {
  onClose: () => void;
  message?: string | string[];
};

export function ApplicationModal(props: Props) {
  const {onClose, message} = props;

  const styles = useStyles(({theme}) => ({
    modalParentError: {
      ...theme.fonts.h5,
      marginTop: 10,
      textAlign: 'center',
    },
    modalKidError: {
      ...theme.fonts.h5,
      marginTop: 10,
      textAlign: 'center',
    },
    modalError: {
      ...theme.fonts.h5,
      marginTop: 60,
      textAlign: 'center',
    },
    modalSuccess: {
      ...theme.fonts.h5,
      marginTop: 20,
      textAlign: 'center',
    },
    modalWrap: {
      alignSelf: 'center',
      paddingHorizontal: 10,
      overflow: 'hidden',
      ...(Platform.OS === 'web' ? {flex: 0.45, maxWidth: 360} : {width: '100%', maxWidth: '95%'}),
    },
    modalInner: {
      minHeight: 0,
    },
    button: {width: '90%', marginTop: 20, alignSelf: 'center'},
    buttonSuccess: {width: '90%', alignSelf: 'center'},
  }));
  const theme = useTheme();

  return message ? (
    <Modal onClose={onClose} wrapStyle={styles.modalWrap} contentStyle={{paddingTop: 0}} innerStyle={styles.modalInner}>
      <CustomScrollView withRefresh={false}>
        <images.Exclamation color={theme.color.primaryColor} height={40} width={40} style={{alignSelf: 'center'}} />
        <View style={{height: `95%`, marginTop: 10}}>
          <View style={{maxHeight: `90%`}}>
            <Text style={styles.modalKidError}>{message}</Text>
          </View>
          <Button
            id='SuccessfulAplicationModalContinueBtn'
            type='secondary'
            style={styles.button}
            onPress={onClose}
            iconProps={{width: 16, height: 19}}
            text='Продолжить'
          />
        </View>
      </CustomScrollView>
    </Modal>
  ) : (
    <Modal onClose={onClose} wrapStyle={styles.modalWrap} contentStyle={{padding: 0}} innerStyle={styles.modalInner}>
      <CustomScrollView withRefresh={false}>
        <images.CheckMark color={'green'} height={40} width={40} style={{alignSelf: 'center'}} />
        <View>
          <View>
            <Text style={styles.modalSuccess}>Ваше заявление успешно отправлено</Text>
          </View>
          <View style={{marginTop: 50}}>
            <Button
              id='SuccessfulAplicationModalContinueBtn'
              type='secondary'
              style={styles.buttonSuccess}
              onPress={onClose}
              iconProps={{width: 16, height: 19}}
              text='Продолжить'
            />
          </View>
        </View>
      </CustomScrollView>
    </Modal>
  );
}
